import template from './sw-category-view-override.html.twig';

Shopware.Component.override('sw-category-view', // <-- this is the original component
    {
        template
    }
);